import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import { SimpleBanner } from 'features/Banners/SimpleBanner';
import { segment } from 'helpers/segment';
import { ShowFriendbuyWidget } from 'components/CallToAction/actions';

export class ReferAFriendBanner extends Component {
  handleClick = () => {
    segment.track('raf-banner-click', {
      category: 'Refer-a-Friend',
      label: window.location.pathname,
      value: 0,
    });
    ga('Refer-a-Friend', 'raf-banner-click', window.location.pathname, 0);
  };

  handleClose = () => {
    segment.track('raf-banner-close', {
      category: 'Refer-a-Friend',
      label: window.location.pathname,
    });
    ga('Refer-a-Friend', 'raf-banner-close', window.location.pathname);
    this.props.onClose();
  };

  render() {
    const { rafSenderReward } = this.props;

    return (
      <SimpleBanner onClose={this.handleClose} type="yellow">
        <ShowFriendbuyWidget onClick={this.handleClick}>
          <FormattedMessage
            id="banner.raf.message"
            defaultMessage="Refer friends to get {rafSenderReward}"
            values={{ rafSenderReward }}
          />
        </ShowFriendbuyWidget>
      </SimpleBanner>
    );
  }
}

ReferAFriendBanner.propTypes = {
  rafSenderReward: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
